import { Link } from 'react-router-dom';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { Container as EmptyStateContainer } from 'components/empty-state';
import Modal from 'components/modal';

export const ModalInner = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${Styles.color.grey.five};

  h2 {
    text-align: center;
    margin: 2rem 0;
    text-transform: ${Styles.textTransform.headlines};
    font-family: ${Styles.fontFamily.base};
  }
`;

export const StyledModal = styled(Modal)`
  ${Styles.desktop`
    &[data-reach-dialog-content] {
      width: 90%;
      min-height: 95%;
      max-width: 650px;
    }
  `};
`;

export const Footer = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  border-top: 1px solid ${Styles.color.grey.four};
  padding: 1rem 0;
  background-color: ${Styles.color.grey.five};

  p {
    color: ${Styles.color.grey.one};
  }
`;

export const Container = styled.div`
  width: 90%;
  max-width: 390px;
  margin: 0 auto;
`;

export const ScrollContainer = styled.div`
  position: relative;
  height: calc(100% - 164px);
  padding-top: 7.75rem;
  overflow-y: auto;
`;

export const Block = styled.div`
  padding: 0 0 1rem 0;

  :nth-of-type(n + 2) {
    border-top: 1px solid ${Styles.color.grey.four};
    padding: 1rem 0;
  }

  p {
    color: ${Styles.color.grey.one};
    margin: 0;
  }
`;

export const Item = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;

  h4 {
    font-family: ${Styles.fontFamily.base};
    text-transform: ${Styles.textTransform.headlines};
    margin: 0.5rem 0;
    padding-right: 40px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
`;

export const SpacedRow = styled.div<{ total?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: ${p => (p.total ? '0.8rem' : 0)};
`;

export const EntryDescriptionRow = styled.p`
  font-size: 0.85rem;
  width: 100%;
`;

export const FeeDeliveryItem = styled.p`
  margin: 0;
  text-transform: ${Styles.textTransform.headlines};
`;

export const LoadingContainer = styled.div`
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalHead = styled.div`
  position: fixed;
  background-color: ${Styles.color.grey.five};
  width: 100%;
  height: 5.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  z-index: ${Styles.zIndex.top};

  ${Styles.desktop`
    flex-direction: row;
  `}

  h2 {
    margin: 0;
  }
`;

export const TrackOrderLink = styled(Link)`
  border: 1px solid ${Styles.color.primary};
  border-radius: 2rem;
  margin: 0.35rem 0;
  padding: 0.3rem 0.75rem 0.2rem;
  font-size: 0.7em;
  color: ${Styles.color.primary};
  appearance: none;
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  ${Styles.desktop`
    position: absolute;
    right: 2rem;
    top: 1.7rem;
`}
  &:hover {
    background: ${Styles.color.primary};
    color: ${Styles.color.white};
  }
`;

export const Label = styled.p`
  width: 8rem;
  margin-right: 0.5rem;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const Data = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OrderDetailsScrollContainer = styled.div`
  position: relative;
  height: calc(100% - 164px);
  padding-top: 7.75rem;
  padding-bottom: 2.25rem;
  overflow-y: auto;
`;

export const Tile = styled.div`
  background: ${Styles.color.white};
  box-shadow: ${Styles.boxShadow};
  border-radius: ${Styles.borderRadius};
  padding: 0.8rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  :nth-of-type(n + 1) {
    margin-top: 1rem;
  }

  ${Styles.desktop`
    min-height: 174px;
    padding: 2rem 4rem;
    justify-content: space-between;
    flex-direction: row;
  `}
`;

export const Col = styled.div`
  width: 100%;

  :nth-of-type(2n + 1) {
    margin-bottom: 1.5rem;
  }

  ${Styles.desktop`
    width: 48%;
    margin-bottom: 0;

    :nth-of-type(2n + 1) {
      margin-bottom: 0;
    }

    :nth-of-type(n + 2) {
      margin-left: 2%;
    }
  `}
`;

export const ButtonCol = styled(Col)`
  display: flex;
`;

export const MoreItems = styled.button`
  color: ${Styles.color.primary};
  background: none;
  border: none;
  padding: 0;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
export const FormattedDate = styled.div`
  font-size: 1.375rem;
  font-family: ${Styles.fontFamily.base};
  text-transform: ${Styles.textTransform.headlines};
  margin-bottom: 0.3rem;
`;

export const SubtitleContainer = styled.p`
  display: inline-flex;
  font-weight: ${Styles.fontWeight.heavy};
  align-items: center;
  color: ${Styles.color.grey.one};
`;

export const CateringPendingApproval = styled.p`
  font-size: 0.875rem;
  font-family: ${Styles.fontFamily.body};
  color: ${Styles.color.error};
  margin: 0;
`;

export const NumItems = styled.span`
  margin-left: 5px;
`;

export const Items = styled.p`
  position: relative;
  line-height: 1.5rem;
  max-height: 3rem;
  padding-right: 1rem;
  overflow: hidden;
  margin: 0;
`;

const Btn = styled(ActionButton)`
  width: 49%;
  padding-right: 0;
  padding-left: 0;

  :nth-of-type(n + 2) {
    margin-left: 2%;
  }
`;

export const BtnSecondary = styled(Btn)`
  border: 1px solid ${Styles.color.primary};
  background-color: transparent;
  color: ${Styles.color.primary};

  :hover {
    background-color: transparent;
    text-decoration: underline;
  }
`;

export const ItemNameContainer = styled.div`
  display: flex;
  align-items: center;

  p {
    color: ${Styles.color.grey.one};
  }
`;

export const Wrap = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;

  ${Styles.desktop`
    height: auto;

    ${EmptyStateContainer}{
      max-width: 800px;
    }
  `}
`;

export const RecentOrderTitle = styled.h2`
  margin: 2rem 0;
  margin-bottom: 20px;
  color: ${Styles.color.black} !important;
  font-size: 2.25rem;
  text-align: center;
  ${Styles.desktop`
    font-size: 3.5rem;
  `}
`;

export const OrderNumber = styled.p`
  font-size: 16px;
  font-weight: ${Styles.fontWeight.heavy};
  line-height: 20px;
  color: ${Styles.color.accent};
  margin: 0;
`;

export const OrderNumberWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px 0px;
`;

export const OrderNumberText = styled.p`
  font-size: 16px;
  font-weight: ${Styles.fontWeight.heavy};
  line-height: 20px;
  text-transform: capitalize;
  margin: 0px 4px 0 0;
`;

export const TicketNumber = styled.p`
  && {
    color: ${Styles.color.accent};
  }
`;
